import { ProductInfoForKey, ProductKey } from "libs/product/src/lib/models/product.model";
import { TreatmentPackages } from "../models";

export class ProfessionalPackagesService {

	/**
	 * Checks whether the treatment is running depending on the state of the packages
	 * @param packages
	 * @returns true, if packages have already been ordered
	 */
	public static isTreatmentRunning( packages: TreatmentPackages ) : boolean {
		if(!packages){
			return false;
		}
		return packages.next > 0;
	}

	/**
	 * Checks whehter all regular packages are already ordered by the customer
	 * @param packages
	 * @returns true, if next package would be a (chargeable) correction package
	 */
	public static areRegularPackagesConsumed( packages: TreatmentPackages) : boolean {
		if(!packages || !packages.steps || !Array.isArray(packages.steps) || packages.steps.length === 0){
			return false;
		}
		return packages.next >= packages.steps.length;
	}

	/**
	 * Calculates the number and size of packages for a specific product based on the total steps
	 * @param totalBasePackageSteps
	 * @returns the calculated package structure
	 */
	public static generatePackageStructure(productKey: ProductKey, totalBasePackageSteps: number): TreatmentPackages {
		const productInfo = ProductInfoForKey[productKey];
		const defaultPackageSize = productInfo.basePackageSize;
		const maxPackageSteps = defaultPackageSize * productInfo.maxBasePackages;

		// Validate that the total steps do not exceed the maximum allowed
		if (totalBasePackageSteps > maxPackageSteps) {
		   throw new Error(`The total steps (${totalBasePackageSteps}) exceed the maximum allowed (${maxPackageSteps}) for ${productKey}`);
		}

		const steps: number[] = [];

		while (totalBasePackageSteps > 0) {
		  const stepsPerPackage = Math.min(defaultPackageSize, totalBasePackageSteps);
		  steps.push(stepsPerPackage);
		  totalBasePackageSteps -= stepsPerPackage;
		}

		// Get correction packages
		const freeCorrections = productInfo.corrections;
		return { steps, freeCorrections, addCorrections: [], next: 0 };
	  }

	  /**
	   * Returns the total count of all professional packages
	   * @param packages
	   * @returns count as number
	   */
	  public static getTotalPackageCount( packages: TreatmentPackages ): number {
			if (!packages){
				return 0;
			}
			return packages.steps.length + packages.freeCorrections.length + packages.addCorrections.length;
	  }
}
